const constructCurrencyOptions = (countryMappingDetails = [], selectedCountry) => {
    const currencyOptions = [];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { countryCurrencyList = [] } = selectedCountryMapping;
    countryCurrencyList.map(currency => currencyOptions.push({ id: currency, label: currency }));
    return currencyOptions
}

const constructVendorOptions = (countryMappingDetails = [], selectedCountry) => {
    const vendorOptions = [];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { vendors = [] } = selectedCountryMapping;
    vendors.map(vendor => vendorOptions.push({ id: vendor, label: vendor }));
    return vendorOptions
}

const constructPaymentTypeOptions = (countryMappingDetails = [], selectedCountry, vendorName) => {
    const paymentTypeOptions = [{ id: '', label: '' }];
    const selectedCountryMapping = countryMappingDetails.find(countryMapping => countryMapping.countryCode === selectedCountry) || {};
    const { countryPaymentMap = {} } = selectedCountryMapping;
    if (vendorName && countryPaymentMap[`${vendorName}`]?.length) {
        countryPaymentMap[`${vendorName}`].map(paymentType => paymentTypeOptions.push({ id: paymentType, label: paymentType }));
    }
    return paymentTypeOptions
}

const constructLogisticsService = () => {
    const serviceOptions = [
        { id: '', label: '' },
        { id: 'Available', label: 'Available' },
        { id: 'Not Available', label: 'Not Available' }];
    return serviceOptions
}

const constructOnsiteProcessingService = () => {
    const serviceOptions = [
        { id: '', label: '' },
        { id: 'Available', label: 'Available' },
        { id: 'Not Available', label: 'Not Available' }];
    return serviceOptions
}

const constructDirectCustomerPricingOptions = () => {
    const pricingOptions = [
        { id: '', label: '' },
        { id: 'Margins only', label: 'Margins only' },
        { id: 'Customer Service RateCard', label: 'Customer Service RateCard' }
    ];
    return pricingOptions
}

const revitalizeInCountryOptions = () => {
    const revitalizeCountryOptions = [
        { id: '', label: '' },
        { id: 'Not active', label: 'Not active' },
        { id: 'Active', label: 'Active' },
        { id: 'Not available', label: 'Not available' }
    ];
    return revitalizeCountryOptions
}

const constructCustomerServiceRateCardOptions = (customerServiceRateCardList, country) => {
    const rateCardOptions = [{ id: '', label: '' }, { id: 'HP Standard Customer Service Rate Card', label: 'HP Standard Customer Service Rate Card' }];
    const filteredData = customerServiceRateCardList ? customerServiceRateCardList.filter(item => item.countryCode === country) : [];
    filteredData.map(rateCard => rateCardOptions.push({ id: rateCard.priceList, label: rateCard.priceList }));
    return rateCardOptions
}

export default function countryAndPaymentTypeColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];
    const { countryAndPaymentTypeList = [], countryMappingDetails = [], dealStatus, customerServiceRateCard, isRetrievedDeal } = config.data;

    countryAndPaymentTypeList.forEach((countryAndPaymentTypeOption, index) => {
        let row = [];
        const rowId = countryAndPaymentTypeOption.country;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;
            let isDisabled = false;
            let columnValue = null;
            let columnValueData = null;
            let clickHandler = null;

            if (columnDataType === "select") {
                if (columnId === "vendorSelected") {
                    columnValue = countryAndPaymentTypeOption.selectedVendorCountryPayment ? countryAndPaymentTypeOption.selectedVendorCountryPayment :countryAndPaymentTypeOption.vendorName;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    if (countryAndPaymentTypeOption?.vendorList && countryAndPaymentTypeOption.vendorList.length) {
                        columnValueData.options = countryAndPaymentTypeOption.vendorList.map(vendor => ({ id: vendor.vendorName, label: vendor.vendorName }));
                    } else {
                        columnValueData.options = constructVendorOptions(countryMappingDetails, countryAndPaymentTypeOption.country);
                    }
                    isDisabled = (dealStatus === "COMPLETED" || (countryAndPaymentTypeOption.isRetrieved && !countryAndPaymentTypeOption.vendorList) || (isRetrievedDeal && !countryAndPaymentTypeOption.isRetrieved)) ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                } else if (columnId === "currency") {
                    columnValue = countryAndPaymentTypeOption.currency || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    if (countryAndPaymentTypeOption?.vendorList && countryAndPaymentTypeOption.vendorList.length) {
                        columnValueData.options = countryAndPaymentTypeOption.vendorList.map(vendor => ({ id: vendor.currency, label: vendor.currency }));
                    } else {
                        columnValueData.options = constructCurrencyOptions(countryMappingDetails, countryAndPaymentTypeOption.country);
                    }
                    isDisabled = (dealStatus === "COMPLETED" || countryAndPaymentTypeOption.isRetrieved || (isRetrievedDeal && !countryAndPaymentTypeOption.isRetrieved)) ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                } else if (columnId === "paymentType") {
                    columnValue = countryAndPaymentTypeOption.paymentType || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = constructPaymentTypeOptions(countryMappingDetails, countryAndPaymentTypeOption.country, countryAndPaymentTypeOption.vendorName);
                    isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved) ? true : false;

                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                } else if (columnId === "specialLogistics") {
                    columnValue = countryAndPaymentTypeOption.specialLogistics || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = constructLogisticsService();
                    isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved) ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                } else if (columnId === "onsiteProcessing") {
                    columnValue = countryAndPaymentTypeOption.onsiteProcessing || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = constructOnsiteProcessingService();
                    isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved) ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                } else if (columnId === "directCustomerPricing") {
                    if (countryAndPaymentTypeOption.paymentType === "No Customer Payment") {
                        columnValue = countryAndPaymentTypeOption.directCustomerPricing || "";
                        isDisabled = true;
                    } else {
                        columnValue = countryAndPaymentTypeOption.directCustomerPricing || "";
                        columnValueData = { ...column.data };
                        columnValueData.defaultValue = columnValue;
                        columnValueData.options = constructDirectCustomerPricingOptions();
                        isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved) ? true : false;
                        clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                    }
                } else if (columnId === "customerServiceRateCard") {
                    columnValue = countryAndPaymentTypeOption.customerServiceRateCard || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = constructCustomerServiceRateCardOptions();
                    isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved || countryAndPaymentTypeOption.directCustomerPricing !== 'Customer Service RateCard') ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                
                } else if (columnId === "revitalizeCountry") {
                    columnValue = countryAndPaymentTypeOption.revitalizeCountry || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = countryAndPaymentTypeOption.revitalizeDeal === 'Active' ? revitalizeInCountryOptions() : [{
                        id: countryAndPaymentTypeOption.revitalizeCountry,
                        label: countryAndPaymentTypeOption.revitalizeCountry
                    }];
                    isDisabled = (dealStatus === "COMPLETED" || !countryAndPaymentTypeOption.isRetrieved) ? true : false;
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                }
            }

            if (columnDataType === "string") {
                if (columnId === "countryName") {
                    columnValue = countryAndPaymentTypeOption.country || "";
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    disabled: isDisabled,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    clickHandler: clickHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
